import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { useMeasure } from 'react-use';

interface ScaleContainerProps {
  className?: string;
  children: React.ReactNode;
  targetWidth: number;
  targetHeight: number;
  enabledScale?: boolean;
}

export function ScaleContainer({
  children,
  className,
  targetWidth,
  targetHeight,
  enabledScale = true,
}: ScaleContainerProps) {
  const [scaleFactor, setScaleFactor] = useState<number>(1);
  const [height, setHeight] = useState<number>(targetHeight);
  const [ref, { width: runtimeWidth }] = useMeasure<HTMLDivElement>();

  useEffect(() => {
    const scaleFactor = runtimeWidth / targetWidth;
    setScaleFactor(scaleFactor);
    setHeight(scaleFactor * targetHeight);
  }, [runtimeWidth]);

  if (!enabledScale) return children;

  return (
    <motion.div
      initial={false}
      animate={{ height: height }}
      className={clsx('grid place-content-center', className)}
      ref={ref}
    >
      <motion.div initial={false} animate={{ scale: scaleFactor, width: `${targetWidth}px` }}>
        {children}
      </motion.div>
    </motion.div>
  );
}
